export default {
  attachmentItemComponent: 'attachment-item',
  anchorEditor: true,
  anchorPreview: true,
  attributeInserter: true,
  allowMediaInserter: true,
  textFormatter: true,
  allowFilePaste: true,
  allowUploads: true,
  allowMention: false,
  allowAlignment: false,
  allowAttachments: true,
  allowAttribute: true,
  allowBold: true,
  allowItalic: true,
  allowAnchor: true,
  allowHeading: true,
  allowMarkdownHeadings: true,
  allowMarker: true,
  allowSubheading: true,
  allowOrderedList: true,
  allowUnorderedList: true,
  allowImage: true,
  allowButton: true,
  allowVideo: true,
  allowVideoFile: false,
  allowSocial: true,
  allowCode: true,
  allowHtml: false,
  allowEmoji: false,
  allowAnchorEditorHeader: false,
  readOnly: false,
  displaySocialBlocksAsButtons: false,
  urlReplacement: true,
  // Perform automatic conversion of URLs to anchors
  markdownLinks: true,
  // Convert markdown links to anchors
  markdownInlineCode: false,
  autoFocusTopLeft: true,
  allowedImageTypes: ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'],
  allowedVideoTypes: ['video/mp4'],
  allowedFileTypes: ['*'],
  recoverErrors: true,
  allowRtl: false,
  stripEmptyTrailingBlocks: false,
  videoFileAutoplay: false,
  videoFileMuted: true
};